import { Actions, thunk } from 'easy-peasy';
import formatMedication from '~/utils/formatMedication';
import api from '~/services/api';
import { IThunkUpdateMedication, IClientDetailsStore, IClientDetailsActions } from '../types';

const onUpdateMedication: IThunkUpdateMedication = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    const { requestInfo, requestPayload } = payload;

    const medication = await api.clientDetails
      .updateClientMedication(requestInfo, requestPayload)
      .then(r => formatMedication(r.data));

    const medications = localState.medications.map(item =>
      item.id !== medication.id ? item : medication,
    );

    setClientDetails({ medications });
  },
);

export default onUpdateMedication;
